// src/views/login/login.service.js
import axios from 'axios';

const api = axios.create({
  // Si usas Vue CLI, puedes definir VUE_APP_API_BASE_URL en tu .env
  baseURL: process.env.VUE_APP_API_BASE_URL || '/',
  timeout: 15000,
});

export const loginRequest = async ({ email, password }) => {
  const { data } = await api.post('/api/login_post', { email, password });
  return data; // { success, user, error, ... }
};
